var map = {
	"./audio-placeholder": 663,
	"./audio-placeholder.png": 663,
	"./avatar-missing": 354,
	"./avatar-missing.png": 354,
	"./avatar-missing.svg": 898,
	"./halloween/clouds": 664,
	"./halloween/clouds.png": 664,
	"./halloween/halloween-emblem": 679,
	"./halloween/halloween-emblem.svg": 679,
	"./halloween/spider": 680,
	"./halloween/spider.svg": 680,
	"./halloween/spiderweb": 681,
	"./halloween/spiderweb.svg": 681,
	"./halloween/starfield": 682,
	"./halloween/starfield.png": 682,
	"./halloween/twinkle": 683,
	"./halloween/twinkle.svg": 683,
	"./header-missing": 363,
	"./header-missing.png": 363,
	"./reticle": 684,
	"./reticle.png": 684,
	"./soapbox-logo": 364,
	"./soapbox-logo-white": 365,
	"./soapbox-logo-white.svg": 365,
	"./soapbox-logo.svg": 364,
	"./sprite-post-functions": 685,
	"./sprite-post-functions.png": 685,
	"./video-placeholder": 686,
	"./video-placeholder.png": 686,
	"./void": 687,
	"./void.png": 687,
	"./web-push/web-push-icon_expand": 821,
	"./web-push/web-push-icon_expand.png": 821,
	"./web-push/web-push-icon_favourite": 822,
	"./web-push/web-push-icon_favourite.png": 822,
	"./web-push/web-push-icon_reblog": 823,
	"./web-push/web-push-icon_reblog.png": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 897;